import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  headerTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
  },
  fieldTitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    textDecoration: 'underline',
  },
  greyText: {
    color: '#aaa',
    marginLeft: 5,
  },
  red: {
    color: '#FF0000',
    '&>.MuiTableCell-body': {
      color: '#FF0000',
      fontWeight: 'bold',
    },
  },
  simulateBtn: {
    width: theme.spacing(20),
  },
}));

export default useStyles;
